import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useParametres from "./hooks/useParametres";

import ContactSocialPanel from "./components/ContactSocialPanel";
import HomeSettingsPanel from "./components/HomeSettingsPanel";
import LogoClubCard from "./components/LogoClubCard";
import SaveSettingsBar from "./components/SaveSettingsBar";
import SettingsHero from "./components/SettingsHero";
import SettingsStats from "./components/SettingsStats";
import SettingsTabs from "./components/SettingsTabs";
import useScrollToTop from "../../../../hooks/useScrollToTop";

export default function Parametres() {
  useScrollToTop();
  const {
    activeTab,
    setActiveTab,
    settings,
    galleries,
    loading,
    saving,
    uploadingLogo,
    hasUnsavedChanges,
    stats,
    actions,
  } = useParametres();

  return (
    <div className="space-y-6 pb-24">
      <SettingsHero
        loading={loading}
        settings={settings}
        activeTab={activeTab}
        onChangeTab={setActiveTab}
        onRefresh={actions.refreshData}
      />

      <SettingsStats loading={loading} stats={stats} />

      <SettingsTabs
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        stats={stats}
      />

      {activeTab === "identity" && (
        <div className="grid gap-6 xl:grid-cols-[minmax(0,1.35fr)_380px]">
          <section className="rounded-[2rem] border border-slate-200 bg-white p-5 shadow-sm shadow-slate-200/60 dark:border-slate-800 dark:bg-slate-900 dark:shadow-none">
            <div>
              <p className="text-sm font-bold uppercase tracking-[0.18em] text-orange-600 dark:text-orange-300">
                Désignation du club
              </p>
              <h2 className="mt-2 text-2xl font-bold text-slate-950 dark:text-white">
                Identité et informations administratives
              </h2>
              <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
                Ces informations servent à personnaliser le site visiteur et à
                identifier clairement la structure.
              </p>
            </div>

            <div className="mt-6 grid gap-4 md:grid-cols-2">
              <div>
                <label className="mb-1.5 block text-sm font-bold text-slate-700 dark:text-slate-200">
                  Nom du club
                </label>
                <input
                  type="text"
                  name="nom_club"
                  value={settings.nom_club}
                  onChange={actions.handleChange}
                  placeholder="Ex : Judo Club..."
                  className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-700 outline-none transition focus:border-orange-400 focus:bg-white focus:ring-4 focus:ring-orange-100 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:focus:ring-orange-500/10"
                />
              </div>

              <div>
                <label className="mb-1.5 block text-sm font-bold text-slate-700 dark:text-slate-200">
                  Nom court
                </label>
                <input
                  type="text"
                  name="shortname_club"
                  value={settings.shortname_club}
                  onChange={actions.handleChange}
                  placeholder="Ex : JCB"
                  className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-700 outline-none transition focus:border-orange-400 focus:bg-white focus:ring-4 focus:ring-orange-100 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:focus:ring-orange-500/10"
                />
              </div>

              <div>
                <label className="mb-1.5 block text-sm font-bold text-slate-700 dark:text-slate-200">
                  Responsable du club
                </label>
                <input
                  type="text"
                  name="responsable_club"
                  value={settings.responsable_club}
                  onChange={actions.handleChange}
                  placeholder="Nom du responsable"
                  className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-700 outline-none transition focus:border-orange-400 focus:bg-white focus:ring-4 focus:ring-orange-100 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:focus:ring-orange-500/10"
                />
              </div>

              <div>
                <label className="mb-1.5 block text-sm font-bold text-slate-700 dark:text-slate-200">
                  SIRET
                </label>
                <input
                  type="text"
                  name="siret_club"
                  value={settings.siret_club}
                  onChange={actions.handleChange}
                  placeholder="Numéro SIRET"
                  className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-700 outline-none transition focus:border-orange-400 focus:bg-white focus:ring-4 focus:ring-orange-100 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:focus:ring-orange-500/10"
                />
              </div>
            </div>
          </section>

          <LogoClubCard
            settings={settings}
            uploadingLogo={uploadingLogo}
            onLogoChange={actions.handleLogoChange}
          />
        </div>
      )}

      {activeTab === "contact" && (
        <ContactSocialPanel
          settings={settings}
          onChange={actions.handleChange}
        />
      )}

      {activeTab === "home" && (
        <HomeSettingsPanel
          settings={settings}
          galleries={galleries}
          loading={loading}
          onChange={actions.handleChange}
          onQuillChange={actions.handleQuillChange}
        />
      )}

      <SaveSettingsBar
        saving={saving}
        loading={loading}
        hasUnsavedChanges={hasUnsavedChanges}
        onSave={actions.handleSubmit}
        onReset={actions.resetChanges}
      />

      <ToastContainer position="bottom-right" theme="colored" />
    </div>
  );
}